import { db, auth, COLLECTIONS, SUBCOLLECTIONS } from "../../firebase/firebase";
import {
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  collection,
  getDocs,
  QueryDocumentSnapshot,
  query,
  where,
  limit,
  startAfter,
  QueryConstraint,
  and,
  QueryCompositeFilterConstraint,
  QueryNonFilterConstraint,
  QueryFieldFilterConstraint,
  Timestamp,
  collectionGroup,
  orderBy,
  getCountFromServer,
  setDoc,
  endBefore,
  limitToLast
} from "firebase/firestore";


import { CustomError } from "../../utils/customeError";
import { ApplicationActionType, ApplicationState,  ApplicationForm } from "../../models/SKApplication";
import { Pagination } from "../enums";
import { removeUndefined } from "../../utils/stringFunctions";



const saveApplication = async (data:any) : Promise<string> => {
  if(auth.currentUser?.uid){
    try {
      let applicationData = {...data, userId: auth.currentUser.uid, status:ApplicationState.DRAFT}
      await setDoc(doc(db, COLLECTIONS.APPLICATIONS, auth.currentUser?.uid), removeUndefined(applicationData), { merge: true });
      return auth.currentUser?.uid;
    } catch (error) {
      throw new CustomError('An error occurred while creating Application');
    }
  }else{
    throw new CustomError('User not signed in');
  }
};



const getApplication = async (applicationId: string) : Promise<ApplicationForm> => {
  const docSnap = await getDoc(doc(db, COLLECTIONS.APPLICATIONS, applicationId));
  if (docSnap.exists()) {
    const documents = {
      id: docSnap.id,
      ...docSnap.data(),
    } as ApplicationForm ;
    return documents;
  } else {
    throw new Error("Application does not exist!");
  }
};


const getApplicationsByIds = async (ids: string[]) : Promise<ApplicationForm[]> => {
   
  const colRef = collection(db, COLLECTIONS.APPLICATIONS);

  // Use "where" clause with "__name__" for document IDs
  const q = query(colRef, where("__name__", "in", ids));
  const querySnapshot = await getDocs(q);

  const documents = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  } as ApplicationForm)) ;

  return documents;
};

/* const getApplicationByStatus = async (status: string) : Promise<ApplicationForm> => {
  const querys = query(collection(db, 'storeApplications'), where('status', '==', 'draft'), where('userId', '==', auth.currentUser?.uid));
  try
  {
    const docSnap = await getDocs(querys);
    const applicationsData = docSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data() as ApplicationForm
    }));
    return applicationsData;
  }
  catch (error) {
    throw new Error("Application does not exist!");
  }

}; */



// querySnapshot.forEach((doc) => {
//   console.log(doc.id, ' => ', doc.data());
// });

const getMyApplication = async (): Promise<ApplicationForm> => {

  let qry = query(collectionGroup(db,COLLECTIONS.APPLICATIONS), where("members", "array-contains", auth.currentUser?.uid))
  
  try {
    const querySnapshot = await getDocs(qry);
    const applicationsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as ApplicationForm[];
    return applicationsData[0];
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};



const applyPaginationQuery = (pageSize: number, moveTo?:Pagination, currentDoc?:QueryDocumentSnapshot): QueryNonFilterConstraint[] =>{

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  switch (moveTo) {
    case Pagination.Next:
      if (currentDoc) {
        myNonFilterQuery.push(startAfter(currentDoc))
        myNonFilterQuery.push(limit(pageSize));
      }
      break;

    case Pagination.Previous:
      if (currentDoc) {
        myNonFilterQuery.push(endBefore(currentDoc))
        myNonFilterQuery.push(limitToLast(pageSize));
      }
      break;

    case Pagination.First:
      myNonFilterQuery.push(limit(pageSize));
      break;

    case Pagination.Last:
      myNonFilterQuery.push(limitToLast(pageSize));
      break;

    // default:
    //   myNonFilterQuery.push(limit(pageSize));
      
  }

  return myNonFilterQuery;

}

 const fetchApplication = async (filterFields: string[], operator:string, filterValues: unknown[], pageSize: number, lastDocument?:QueryDocumentSnapshot, moveTo?:Pagination, sortConfig?:{key:string; direction: "asc" | "desc"} ): Promise<{docs:ApplicationForm[]; firstDoc: QueryDocumentSnapshot | undefined; lastDoc: QueryDocumentSnapshot | undefined, hasNext:boolean, hasPrev:boolean }> => {
  let ref = collection(db, COLLECTIONS.APPLICATIONS)
  // let myNonFilterQuery: QueryNonFilterConstraint[] = []
  // myNonFilterQuery.push(limit(pageSize ? pageSize + 1 :  10))

  let myNonFilterQuery = applyPaginationQuery(moveTo === Pagination.Last ? pageSize: pageSize + 1 ,moveTo, lastDocument);

  let constratints:QueryFieldFilterConstraint[]  = []
  
  if (filterFields.length > 0 && filterValues.length > 0) {
    for (let i = 0; i < filterFields.length; i++) {
      const fieldPath = filterFields[i] as string;
      const fieldValue = filterValues[i] as string;
      if(fieldPath && fieldValue) constratints.push(where(fieldPath, '==', fieldValue));
    }
  }


  // if (lastDocument) {
  //   myNonFilterQuery.push(startAfter(lastDocument))
  // }

  let compositeQuery: QueryCompositeFilterConstraint =  and(...constratints)

  let sortArray = [orderBy("createdDate", "desc")]

  if(sortConfig){
    sortArray= [orderBy(sortConfig.key, sortConfig.direction)]
  }

  const q  = query(ref, compositeQuery ,...sortArray, ...myNonFilterQuery);
  try {
    const querySnapshot = await getDocs(q);
    // const applicationsData = querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   ...doc.data()
    // })) as ApplicationForm[];

        const docs = querySnapshot.docs.slice(0, pageSize).map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as ApplicationForm[];
    
        // const firstDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[0] : undefined;
        // const lastDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : undefined;
        // const hasNext = querySnapshot.size === pageSize;
    
        let firstDoc = querySnapshot.size > 0 ? querySnapshot.docs[0] : undefined;
        // setLastVisible(docs.length > pageSize ? docs[pageSize - 1] : null);
        let lastDoc = querySnapshot.size > pageSize ? querySnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? querySnapshot.docs[pageSize - 1]: undefined);
        let hasNext = moveTo === Pagination.Next ? querySnapshot.size > pageSize :  moveTo === Pagination.First && querySnapshot.size <= pageSize ? false : true;
        
    
        let hasPrev = !!lastDocument;
        switch (moveTo) {
          case Pagination.First:
            hasPrev = false
            break;
          case Pagination.Last:
            hasNext = false
            break;
          default:
            break;
        }
        return {docs,firstDoc,lastDoc,hasNext, hasPrev };

    // return applicationsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

 const updateApplication = async (applicationId: string, data: any) => {
  await setDoc(doc(db, COLLECTIONS.APPLICATIONS, applicationId), removeUndefined(data), { merge: true });
};


const updateApplicationStatus = async (applicationId: string, status: ApplicationState, reason?:string, note?:string,): Promise<void> =>  {
  try {
    console.log(status)
    console.log(applicationId)
    let applicationData = {status, updatedDate: Timestamp.now()}
    await updateApplication(applicationId, applicationData);
    //await updateApplicationHistory(applicationId, status, reason, note)
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const updateApplicationHistory = async ( applicationId:string, status:string, reason?:string, note?:string ) : Promise<void> => {
  try {
    if(reason){
      if(note){
        await addDoc(collection(db, COLLECTIONS.APPLICATIONS, applicationId, SUBCOLLECTIONS.APPLICATION_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason, note} );
      }else{
        await addDoc(collection(db, COLLECTIONS.APPLICATIONS, applicationId, SUBCOLLECTIONS.APPLICATION_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason} );
      }
    }else{
      await addDoc(collection(db, COLLECTIONS.APPLICATIONS, applicationId, SUBCOLLECTIONS.APPLICATION_STATUS_LOGS ), {status, createdDate: Timestamp.now()} );
    }
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while updating Artefact Status');
  }
};




const getApplicationCounts = async (): Promise<{ [ApplicationActionType.approved]:number,[ApplicationActionType.rejected]:number, [ApplicationActionType.submitted]: number }> => {
  const applicationsRef = collection(db, COLLECTIONS.APPLICATIONS);

  const approvedQuery = query(applicationsRef, where("status", "==", ApplicationState.APPROVED));
  const rejectedQuery = query(applicationsRef, where("status", "==", ApplicationState.REJECTED));
  const submitedQuery = query(applicationsRef, where("status", "==", ApplicationState.SUBMITTED));
  

  try {
    // Execute all queries in parallel
    const [approvedSnap, rejectedSnap, submittedSnap] = await Promise.all([
      getCountFromServer(approvedQuery),
      getCountFromServer(rejectedQuery),
      getCountFromServer(submitedQuery),
    ]);

    return {
      [ApplicationActionType.submitted]: submittedSnap.data().count,
      [ApplicationActionType.approved]: approvedSnap.data().count,
      [ApplicationActionType.rejected]: rejectedSnap.data().count,
    };
  } catch (error) {
    console.error("Error getting application counts: ", error);
    return {
      [ApplicationActionType.submitted]: 0,
      [ApplicationActionType.approved]: 0,
      [ApplicationActionType.rejected]: 0,
    };
  }
}



export {
  getApplication,
  getMyApplication,
  fetchApplication,
  saveApplication,
  updateApplication,
  updateApplicationStatus,
  getApplicationsByIds,
  getApplicationCounts,
};